import log from "cslog";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import { useCheckUser, useLogin } from "../actions/auth";
import GoogleLoginButton from "../auth/GoogleLoginButton";
import { history } from "../_helpers/history";
import { queryClient } from "../_helpers/query";
import CenterCard from "../_layouts/CenterCard";
import AutoLogin from "./AutoLogin";
import { getAuthIntent } from "../_helpers/auth";
import QUREAL_LOGO from "../media/imgs/0_logo_square.png";
import FacebookLoginButton from "../auth/FacebookLoginButton";
import { Alert, Button, Checkbox, Form, Grid, Input, Typography } from "antd";
import {
    UserOutlined,
    LockOutlined,
    ArrowRightOutlined,
} from "@ant-design/icons";
import CenterCard2Part from "../_layouts/CenterCard2Part";
import SidePreviewScreen from "../_layouts/SidePreviewScreen";
import { LOGO_ONLY } from "../constants";

const { useBreakpoint } = Grid;
const { Text } = Typography;

function useQueryParams() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function LoginNew() {
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const {
        register,
        handleSubmit,
        formState: { errors: errorsForm },
        // watch,
    } = useForm();
    //Try auto logging in
    const query_params = useQueryParams();
    const autologin =
        getAuthIntent() && !(query_params.get("nocheck") === "true");
    // actual login
    const {
        loading: loadingLogin,
        success: successLogin,
        errors: errorsLogin,
        isError: errorLogin,
        login,
    } = useLogin();
    //check user email
    const [email, setEmail] = useState("aaaa");
    const {
        isLoading: loadingCU,
        status: statusCU,
        data: dataCU,
    } = useCheckUser(email, errorLogin && email !== undefined);
    const [current_provider, setCurrentProvider] = useState("credentials");
    const [provider, setProvider] = useState(
        query_params.get("provider") || "both"
    );
    const [error, setError] = useState(query_params.get("error"));
    const [info, setInfo] = useState(false);
    const [form] = Form.useForm();

    log.p("Welcome to Login page");
    log.d(dataCU, "Data CU");
    log.d(email, "Email");
    const [mobile, setMobile] = useState("");
    // useEffect(() => {
    //     if (errorLogin && errorsLogin?.length > 0) {
    //         setError(errorsLogin.map((it) => it.message).join(", "));
    //     }
    // }, [errorsLogin, errorLogin])

    const sendHome = () => {
        const { from } = history.location.state || {
            from: { pathname: "/" },
        };
        history.push(from);
    };

    // useEffect(() => {
    //     const subscription = watch((value, { name, type }) => {
    //         console.log(value);
    //         setEmail(value.email);
    //     });
    //     return () => subscription.unsubscribe();
    // }, [watch]);

    useEffect(() => {
        queryClient.invalidateQueries("user");
    }, []);

    // Combined error handling effect
    useEffect(() => {
        if (!loadingLogin && !loadingCU) {
            if (successLogin) {
                log.p("Sending home after login");
                sendHome();
                return;
            }

            if (errorLogin && errorsLogin?.length > 0) {
                // Handle login errors
                const errorMessage = errorsLogin
                    .map((it) => it.message)
                    .join(", ");
                setError(errorMessage);
                return;
            }

            if (statusCU === "success" && dataCU) {
                if (dataCU.error) {
                    const err_code = dataCU.code;
                    if (err_code === "NOT_EXISTS") {
                        setError("User does not exist");
                        return;
                    }
                }

                if (dataCU.provider !== current_provider) {
                    setError(false);
                    setInfo(
                        `${email} has used ${dataCU.provider} to login. please try ${dataCU.provider} Login`
                    );
                    setProvider(dataCU.provider);
                } else if (dataCU.status !== "active") {
                    setError("User is not active");
                } else if (!successLogin) {
                    setError("Invalid user credentials");
                }
            }
        }
    }, [
        loadingLogin,
        loadingCU,
        successLogin,
        errorLogin,
        errorsLogin,
        statusCU,
        dataCU,
    ]);

    const handleSubmitForm = async (values) => {
        try {
            const mobile = values.mobile;
            let emailValue = mobile;
            if (!emailValue.includes("@")) {
                emailValue = `91${emailValue}@qureal.ai`;
            }
            setEmail(emailValue);
            await login({
                email: emailValue,
                password: values.password,
            });
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <SidePreviewScreen
            title="Welcome to Qureal AI"
            // title="Log In"
            logo={LOGO_ONLY}
            center={false}
            styles_card={{
                width: "100%",
                maxWidth: "500px",
            }}
        >
            <AutoLogin enable={autologin}>
                <Form
                    form={form}
                    name="normal_login"
                    style={{
                        maxWidth: "100%",
                        width: isMobile ? "100%" : "400px",
                    }}
                    onValuesChange={(changedValues) => {
                        if (changedValues.mobile !== undefined) {
                            setMobile(changedValues.mobile);
                        }
                    }}
                    initialValues={{ remember: true }}
                    onFinish={handleSubmitForm}
                    layout="vertical"
                    requiredMark={false}
                >
                    {error && (
                        <Alert
                            type="error"
                            showIcon
                            message={error}
                            style={{
                                marginBottom: "10px",
                            }}
                        />
                    )}
                    <Form.Item
                        name="mobile"
                        rules={[
                            {
                                required: true,
                                message: "Please input your mobile number!",
                            },

                            // {
                            //     type: "email",
                            //     message: "Invalid email",
                            // },
                        ]}
                        normalize={(value) => value.trim()}
                        // hasFeedback
                        label="Mobile number"
                    >
                        <Input
                            // prefix={
                            //     <UserOutlined className="site-form-item-icon" />
                            // }
                            placeholder="Mobile number"
                            onChange={(e) => {
                                e.target.value = e.target.value.trim();
                            }}
                            size="large"
                            addonBefore="+91"
                            style={
                                {
                                    // backgroundColor: "transparent",
                                }
                            }
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please input your Password!",
                            },
                        ]}
                        label="Password"
                        // hasFeedback
                    >
                        <Input.Password
                            // prefix={
                            //     <LockOutlined className="site-form-item-icon" />
                            // }
                            type="password"
                            placeholder="Password"
                            size="large"
                        />
                    </Form.Item>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            // justifyContent: "space-between",
                            padding: "0px 0 10px 0",
                            marginTop: "-5px",
                        }}
                    >
                        {/* <Form.Item
                            name="remember"
                            valuePropName="checked"
                            noStyle
                        >
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item> */}

                        <Link
                            to={`/forgot_password?mobile=${mobile}`}
                            style={
                                isMobile
                                    ? {
                                          fontSize: 16,
                                          padding: "10px 0",
                                          display: "inline-block",
                                      }
                                    : {}
                            }
                        >
                            Forgot password
                        </Link>
                    </div>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            block={isMobile}
                            loading={loadingLogin || loadingCU}
                            icon={<ArrowRightOutlined />}
                            iconPosition="end"
                        >
                            {loadingLogin || loadingCU
                                ? "Signing in"
                                : "Sign in"}
                        </Button>
                    </Form.Item>

                    <div
                        style={{
                            marginBottom: "10px",
                        }}
                    >
                        New here?{" "}
                        <Link
                            to="/register"
                            style={
                                isMobile
                                    ? {
                                          fontSize: 16,
                                          padding: "10px 0",
                                          display: "inline-block",
                                      }
                                    : {}
                            }
                        >
                            Create an account
                        </Link>
                    </div>
                </Form>
            </AutoLogin>
        </SidePreviewScreen>
    );
}

export default LoginNew;
